<script setup lang="js">
const props = defineProps({text:String,color:String})
</script>

<template>
  <div class="text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] py-4" :class="props.color">{{text}}
  </div>
</template>

<style scoped>

</style>
